import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

const EMPTY_PERMISSIONS: readonly string[] = [];

export const selectAuthUser = (state: RootState) => state.auth.user;

export const selectUserPermissions = createSelector(
  [selectAuthUser],
  (user) => user?.permissions ?? EMPTY_PERMISSIONS,
);

export const selectUserRoleCode = (state: RootState) => state.auth.user?.roleCode ?? null;

export const selectEnabledModules = (state: RootState) => state.auth.enabledModules;

export const selectAccessibleModules = (state: RootState) => state.auth.accessibleModules;
